import _ from "lodash"
import CloudNameCheckResult from "./CloudNameCheckResult"

export default class CloudNameChecker {
    

    name = ''
    isPublic = false
    
    icon = ''
    iconcolour = ''
    checkResult: CloudNameCheckResult|null = null

    notValid = false
    hasTriedSave = false
    saving = false
    overwriting = false

    // this could be an array of 2 rules, but I need the side-effect of setting this.notValid 
    nameRules = [
        (v: string) => {
            if (!v)                             { this.notValid = true; return 'Name is required' }
            if ((v||'').length > 50)            { this.notValid = true; return 'Name must be 50 characters or fewer' }

            this.notValid = false;
            return true;
        }
    ]
}